/* __next_internal_client_entry_do_not_use__ Add auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Aidan Simpson (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1766))
 * @trackcomponent
 * @lastsynced 2023-02-14T01:15:34.626Z
 */ export var Add = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M12 1.71429V22.2857",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M1.71436 12H22.2858",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Add", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "pwqcHa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Add"
                }
            ]
        }),
        fill: "none"
    };
});
